import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { Button, Row, Col, Alert } from "reactstrap";
import { useContext } from "react";
import KybCompanyContext from "../../../../contexts/KYBCompanyContext";
import { KYBAvailableServices } from "src/modules/3rd-party-management/constants";
import { Accordion } from "react-bootstrap";
import ListReportResult from "./components/ListReportResult";
import { RiInformationLine } from "react-icons/ri";
import { useHistory } from "react-router-dom";

const Results = ({
    t
}) => {
    const history = useHistory();

    const {
        companyData
    } = useContext(KybCompanyContext);

    const {
        services: selectedServices,
        reports
    } = companyData;

    return (
        <Row>
            <Col sm="12">
                <Alert color="info" className="d-flex align-items-center justify-content-start gap-2">
                    <RiInformationLine size={40} />
                    <div>
                        <strong>{t('Report Retrieval in Progress')}</strong>
                        <p className="mb-0">
                            {t('The reports you selected are being fetched from the providers. Each report may take a few moments to retrieve, and you can monitor the status in the table below. Any errors or issues will be displayed in the status column. You can retry failed reports if needed.')}
                        </p>
                    </div>
                </Alert>
            </Col>

            <Col sm='12' className="mb-3 custom-accordion">
                <Accordion alwaysOpen defaultActiveKey={['0', '1', '2']}>
                    {KYBAvailableServices.filter((service) => {
                        return service.enableFetchReport && selectedServices.includes(service.id) && reports[service.id]?.length > 0
                    }).map((service, i) => {
                        return (
                            <Accordion.Item eventKey={i.toString()}>
                                <Accordion.Header>
                                    <div className="d-flex align-items-center w-100 justify-content-between">
                                        <div className="d-flex align-items-center gap-2">
                                            <span className="fw-semibold">
                                                {service.title} – {t('Reports')}
                                            </span>
                                        </div>
                                    </div>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <ListReportResult
                                        serviceInfo={service}
                                    />
                                </Accordion.Body>
                            </Accordion.Item>
                        )
                    })}
                </Accordion>
            </Col>

            <Col sm='12' className="d-flex justify-content-between">
                <div />
                <div>
                    <Button
                        color="primary"
                        type="button"
                        onClick={() => {
                            history.push({
                                search: `?tab=kyb`
                            })
                        }}
                    >
                        {t('Finish')}
                    </Button>
                </div>
            </Col>
        </Row>
    );
}

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    return {
        user: state.Login.user,
        token: token
    };
};

export default withNamespaces()(
    connect(
        mapStatetoProps,
        {}
    )(Results)
)